import { t } from '@kanbios/ui';

/** D57: the views of the Domaines lists, as every list with a state: « Tout » first, then red, orange, green, grey. */
export const TONE_VIEWS = ['all', 'urgent', 'attention', 'ok', 'other'] as const;
export type ToneView = (typeof TONE_VIEWS)[number];

/** The Segmented items of a list (`domains` or `addresses`), with the counts the backend serves. */
export function toneViewItems(list: 'domains' | 'addresses', counts: Record<ToneView, number> | undefined) {
  return TONE_VIEWS.map(id => ({ id, label: t(`${list}.view.${id}`), count: counts?.[id] }));
}
